import styled from 'styled-components'

import { fromMd } from '@syconium/little-miss-figgy'

import { useSiteWideMessaging } from '../../../app/_providers/SiteWideMessagingProvider.client'
import { ProductDetailsTitle } from '../../../components/pages/products/ProductPage/DetailsSection/ProductDetailsPromoMessages'

export function IntlShippingAndTaxMsg() {
  const { siteWideRegionSpecificDutiesAndFeesMessage, siteWideRegionSpecificShippingMessage } =
    useSiteWideMessaging()
  return (
    <>
      {siteWideRegionSpecificShippingMessage && <div>{siteWideRegionSpecificShippingMessage}</div>}
      {siteWideRegionSpecificDutiesAndFeesMessage && (
        <IntlMsgWrap>{siteWideRegionSpecificDutiesAndFeesMessage}</IntlMsgWrap>
      )}
    </>
  )
}

export const IntlMsgWrap = styled(ProductDetailsTitle)`
  text-align: center;
  margin: ${o => o.theme.spacing(6)};

  ${fromMd} {
    margin: ${o => o.theme.spacing(4)} 0;
  }
`
